<div class="card__section" id="opusJobsTable" [formGroup]="form">
  <p class="typography--body" *ngIf="(opusJobs$ | async)?.length === 0 && criteria?.state">There are no job schedules.</p>
  <div class="table" role="table" *ngIf="(opusJobs$ | async)?.length">
    <span role="rowgroup">
      <span class="table__row table__row--header" role="row">
        <span class="table__cell table__cell--half" role="columnheader">Enabled</span>
        <span class="table__cell table__cell--align-left table__cell--one-half" role="columnheader">Job Name</span>
        <span class="table__cell table__cell--half" role="columnheader">State</span>
        <span class="table__cell table__cell--half" role="columnheader">Next Run</span>
        <span class="table__cell table__cell--half" role="columnheader">Started At</span>
        <span class="table__cell table__cell--half" role="columnheader">Finshed At</span>
        <span class="table__cell table__cell--align-left table__cell--one-half" role="columnheader">Message</span>
        <span class="table__cell table__cell--half" role="columnheader">Schedule</span>
        <span class="table__cell table__cell--half" role="columnheader">Retry Count</span>
        <span class="table__cell table__cell--half" role="columnheader">Retry Delay</span>
      </span>
    </span>
    <div role="rowgroup" formArrayName="opusJobsData">
      <opus-jobs-table-row
        [isEditing]="isEditing"
        [updatingOpusJobs]="updatingOpusJobs"
        *ngFor="let charge of opusJobs$ | async; odd as isOdd; last as isLast; let i = index"
        [chargeItm]="charge"
        [isOdd]="isOdd"
        [isLast]="isLast"
        [item]="form.controls.opusJobsData.controls[i]"
        [relationshipManagerEmail]="relationshipManagerEmail"
      ></opus-jobs-table-row>
    </div>
  </div>
</div>
